<template>
  <div>
    <v-stepper vertical v-model="step" class="px-md-10 px-0">

      <v-stepper-step step="1">
        مرحله ۱
        <small>نوع سفارش</small>
      </v-stepper-step>
      <v-stepper-content step="1" class="mx-0 px-1 pr-2">
        <h5 class="pb-5 text-center"> {{ pageTitle }}</h5>
        <div class="m-3">
          <v-text-field outlined
                        dense
                        v-model="data.organizationName"
                        hint="لطفا نام مجموعه خود را وارد کنید."
                        maxLength="50"
                        counter="50"
                        :rules="this.$rules.requiredString"
                        label="نام مجموعه "
                        append-icon="mdi-domain"/>
        </div>
        <div class="m-3">
          <v-text-field outlined
                        dense
                        v-model="data.brandName"
                        hint="لطفا نام برند خود را  وارد  کنید."
                        maxLength="50"
                        counter="50"
                        :rules="this.$rules.requiredString"
                        label="نام برند "
                        append-icon="mdi-domain"/>
        </div>
        <div class="m-3">
          <v-text-field outlined
                        v-model="data.brandSlogan"
                        dense
                        hint="لطفا شعار برند خود را وارد نمایید"
                        placeholder="لطفا شعار برند خود را وارد نمایید"
                        maxLength="50"
                        counter="50"
                        label="شعار برند"
                        append-icon="mdi-domain"/>
        </div>
        <div class="m-3">
          <v-switch
              v-model="data.slogan"
              dense
              class="text-right"
              :label="data.type!=='logo'?'میخواهم شعار در کارت ویزیت اضافه شود':'میخواهم شعار در لوگو اضافه شود'"
          ></v-switch>
        </div>
        <v-btn class="submit-btn" @click="step1Validate">
          ادامه
          <span class="fa fa-arrow-left mr-1"></span>
        </v-btn>
      </v-stepper-content>

      <v-stepper-step step="2">
        مرحله ۲
        <small>اطلاعات اولیه سفارش</small>
      </v-stepper-step>
      <v-stepper-content class="mx-0 px-1 pr-2" step="2">
        <div class="mt-2">
          <div>
            <v-expansion-panels class="px-1">
              <v-expansion-panel
                  class="mb-4 px-1 customStyle"
                  v-if="data.type==='logo'">
                <v-expansion-panel-header disable-icon-rotate class="px-1">
                  نوع طراحی لوگو را مشخص نمایید.
                  <div v-if="data.logoType && !isMobile">
                    <v-chip
                        v-if="data.logoType"
                        close-icon="mdi-close-outline"
                        color="indigo"
                        small
                        class="mx-2"
                        outlined
                    >{{ names["logoType"] }}
                    </v-chip>
                  </div>
                  <template v-slot:actions>
                    <v-icon v-if="data.logoType && isMobile" color="teal">mdi-check</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <logo-type class="mb-4" v-if="data.type==='logo'" @persianName="persianName"
                             v-model="data.logoType"></logo-type>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel
                  class="mb-4 px-1 customStyle"
                  v-if="data.type==='logo'">
                <v-expansion-panel-header disable-icon-rotate class="px-1">
                  لطفا شکل هندسی لوگو خود را انتخاب نمایید.
                  <div v-if="data.logoShape && !isMobile">
                    <v-chip
                        v-if="data.logoShape"
                        close-icon="mdi-close-outline"
                        color="indigo"
                        small
                        class="mx-2"
                        outlined
                    >{{ names["logoShape"] }}
                    </v-chip>
                  </div>
                  <template v-slot:actions>
                    <v-icon v-if="data.logoShape && isMobile" color="teal">mdi-check</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <logo-shape @persianName="persianName" class="mb-4" v-if="data.type==='logo'"
                              v-model="data.logoShape"></logo-shape>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel
                  class="mb-4 px-1 customStyle"
                  v-if="data.type==='logo' || data.type==='visit_card' "
              >
                <v-expansion-panel-header disable-icon-rotate class="px-1">
                  {{
                    data.type === 'visit_card' ? ' لطفا زبان طراحی کارت خود را انتخاب نمایید.' : 'لطفا زبان طراحی لوگو را انتخاب نمایید.'
                  }}
                  <div v-if="data.logoLanguage && !isMobile">
                    <v-chip
                        v-if="data.logoLanguage"
                        close-icon="mdi-close-outline"
                        color="indigo"
                        small
                        class="mx-2"
                        outlined
                    >{{ names["langType"] }}
                    </v-chip>
                  </div>
                  <template v-slot:actions>
                    <v-icon v-if="data.logoLanguage && isMobile" color="teal">mdi-check</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <lang-type @persianName="persianName" class="mb-4"
                             v-model="data.logoLanguage"
                             v-if="data.type==='logo' || data.type==='visit_card' "></lang-type>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel
                  class="mb-4 px-1 customStyle"
                  v-if="data.type==='visit_card'"
              >
                <v-expansion-panel-header disable-icon-rotate class="px-1">
                  لطفا نوع طرح کارت ویزیت را انتخاب نمایید.
                  <div v-if="data.designType && !isMobile">
                    <v-chip
                        v-if="data.designType"
                        close-icon="mdi-close-outline"
                        color="indigo"
                        small
                        class="mx-2"
                        outlined
                    >{{ names["cardSides"] }}
                    </v-chip>
                  </div>
                  <template v-slot:actions>
                    <v-icon v-if="data.designType && isMobile" color="teal">mdi-check</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <card-sides @persianName="persianName" v-model="data.designType"
                              class="mb-4"></card-sides>

                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel
                  v-if="data.type==='logo'"
                  class="mb-4 px-1 customStyle"
              >
                <v-expansion-panel-header disable-icon-rotate class="px-1">
                  لطفا فرم وحالت طراحی لوگو را مشخص نمایید.
                  <div v-if="data.softness && !isMobile">
                    <v-chip
                        v-if="data.softness"
                        close-icon="mdi-close-outline"
                        color="indigo"
                        small
                        class="mx-2"
                        outlined
                    >{{ names["properties"] }}
                    </v-chip>
                  </div>
                  <template v-slot:actions>
                    <v-icon v-if="data.softness && isMobile" color="teal">mdi-check</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <properties @persianName="persianName" v-model="data.softness" class="mb-4"
                              v-if="data.type==='logo'"></properties>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel
                  v-if="data.type==='logo'"
                  class="mb-4 px-1 customStyle"
              >
                <v-expansion-panel-header disable-icon-rotate class="px-1">
                  لطفا سبک طراحی لوگو را انتخاب نمایید.
                  <div v-if="data.designStyle && !isMobile">
                    <v-chip
                        v-if="data.designStyle"
                        close-icon="mdi-close-outline"
                        color="indigo"
                        small
                        class="mx-2"
                        outlined
                    >{{ names["sabkType"] }}
                    </v-chip>
                  </div>
                  <template v-slot:actions>
                    <v-icon v-if="data.designStyle && isMobile" color="teal">mdi-check</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <sabk-type @persianName="persianName" v-model="data.designStyle" class="mb-4"
                             v-if="data.type==='logo'"></sabk-type>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel class="mb-4 px-1 customStyle"
                                 v-if="data.type==='logo' || data.type==='visit_card'">
                <v-expansion-panel-header disable-icon-rotate class="px-1">
                  {{
                    data.type === 'visit_card' ? '  لطفا رنگ کارت خود را انتخاب نمایید.' : 'لطفا رنگ لوگو را انتخاب نمایید.'
                  }}
                  <div v-if="data.color.length>0 && !isMobile">
                    <v-chip
                        v-if="data.color.length>0"
                        v-for="color in data.color"
                        close-icon="mdi-close-outline"
                        color="indigo"
                        small
                        :color="color"
                        class="mx-2"
                        outlined
                        dense
                    >{{ color }}
                    </v-chip>
                  </div>
                  <template v-slot:actions>
                    <v-icon v-if="data.color.length>0 && isMobile" color="teal">mdi-check</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <color-pickers :count="data.type==='visit_card'? 3 : 2 " v-model="data.color"
                                 class="mb-4"
                                 v-if="data.type==='logo' || data.type==='visit_card'"></color-pickers>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
          <div>
            <v-expansion-panels class="px-1">
              <v-expansion-panel
                  class="mb-4 px-1 customStyle"
                  v-if="data.type==='visit_card'"
              >
                <v-expansion-panel-header disable-icon-rotate class="px-1">
                  لطفا نوع سفارش و طرح خودرا انتخاب کنید.
                  <div class="row mr-2" v-if="!isMobile">
                    <div v-if="data.orderType">
                      <v-chip
                          v-if="data.orderType"
                          close-icon="mdi-close-outline"
                          color="indigo"
                          small
                          class="mx-2"
                          outlined
                      >{{ orderType.find((x) => x.value === data.orderType).text }}
                      </v-chip>
                    </div>
                    <div v-if="data.orderType==='designPrint' && data.printCount">
                      <v-chip
                          v-if="data.printCount"
                          close-icon="mdi-close-outline"
                          color="indigo"
                          small
                          class="mx-2"
                          outlined
                      >{{ data.printCount|currency|persianNum }} عدد
                      </v-chip>
                    </div>
                  </div>
                  <template v-slot:actions>
                    <v-icon v-if="data.orderType && isMobile" color="teal">mdi-check</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-autocomplete
                      v-if="data.type==='visit_card'"
                      class="m-1"
                      v-model="data.orderType"
                      :items="orderType"
                      dense
                      item-text="text"
                      item-value="value"
                      label="نوع سفارش"
                      placeholder="لطفا یک گزینه را انتخاب نمایید."
                      hint="لطفا یک گزینه را انتخاب نمایید."
                      outlined
                  ></v-autocomplete>
                  <v-text-field
                      v-if="data.type==='visit_card' && data.orderType==='designPrint'"
                      class="m-1"
                      v-model="printCounting"
                      dense
                      item-text="text"
                      item-value="value"
                      @keypress="allowOnlyNumbers"
                      label="تعداد چاپ"
                      placeholder="تعداد وارد شده با مضربی از 1000 محاسبه می شود."
                      hint="تعداد وارد شده با مضربی از 1000 محاسبه می شود."
                      outlined
                  ></v-text-field>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel
                  class="mb-4 px-1 customStyle"
                  v-if="data.type==='visit_card' && data.orderType==='designPrint'"
              >
                <v-expansion-panel-header disable-icon-rotate class="px-1">
                  لطفا نوع کارت ویزیت خود را مشخص نمایید.
                  <div v-if="data.visitCardType && !isMobile">
                    <v-chip
                        v-if="data.visitCardType"
                        close-icon="mdi-close-outline"
                        color="indigo"
                        small
                        class="mx-2"
                        outlined
                    >{{ names["visitType"] }}
                    </v-chip>
                  </div>
                  <template v-slot:actions>
                    <v-icon v-if="data.visitCardType && isMobile" color="teal">mdi-check</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <card-type @persianName="persianName" class="mb-4" v-model="data.visitCardType"
                             v-if="data.type==='visit_card'"></card-type>

                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel
                  class="mb-4 px-1 customStyle"
                  v-if="data.type==='visit_card'"
              >
                <v-expansion-panel-header disable-icon-rotate class="px-1">
                  لطفا سبک طراحی کارت ویزیت خودرا مشخص نمایید.
                  <div v-if="data.simpleness && !isMobile">
                    <v-chip
                        v-if="data.simpleness"
                        close-icon="mdi-close-outline"
                        color="indigo"
                        small
                        class="mx-2"
                        outlined
                    >{{ names["sabksType"] }}
                    </v-chip>
                  </div>
                  <template v-slot:actions>
                    <v-icon v-if="data.simpleness && isMobile" color="teal">mdi-check</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <design-type class="mb-4" @persianName="persianName" v-model="data.simpleness"
                               v-if="data.type==='visit_card'"></design-type>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel
                  class="mb-4 px-1 customStyle"
                  v-if="data.type==='visit_card'"
              >
                <v-expansion-panel-header disable-icon-rotate class="px-1">
                  لطفا نوع طراحی کارت ویزیت خود را مشخص نمایید.
                  <div v-if="data.complexity && !isMobile">
                    <v-chip
                        v-if="data.complexity"
                        close-icon="mdi-close-outline"
                        color="indigo"
                        small
                        class="mx-2"
                        outlined
                    >{{ names["headerDesign"] }}
                    </v-chip>
                  </div>
                  <template v-slot:actions>
                    <v-icon v-if="data.complexity && isMobile" color="teal">mdi-check</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <design-paint @persianName="persianName" v-model="data.complexity" class="mb-4"
                                v-if="data.type==='visit_card'"></design-paint>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel
                  class="mb-4 px-1 customStyle"
                  v-if="data.type==='visit_card'"
              >
                <v-expansion-panel-header disable-icon-rotate class="px-1">
                  لطفا شکل هندسی کارت ویزیت را انتخاب نمایید.
                  <div v-if="data.diagram && !isMobile">
                    <v-chip
                        v-if="data.diagram"
                        close-icon="mdi-close-outline"
                        color="indigo"
                        small
                        class="mx-2"
                        outlined
                    >{{ names["shapeCard"] }}
                    </v-chip>
                  </div>
                  <template v-slot:actions>
                    <v-icon v-if="data.diagram && isMobile" color="teal">mdi-check</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <shape-type class="mb-4" @persianName="persianName" v-model="data.diagram"
                              v-if="data.type==='visit_card'"></shape-type>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
        <div class="row justify-content-between py-2 mx-auto">
          <v-btn class="submit-btn col-md-1 col-3" @click="step2Validate">
            ادامه
            <span class="fa fa-arrow-left mr-1"></span>
          </v-btn>
          <v-btn class="mx-4 btn-refund col-md-1 col-3" @click="step = 1">
            <span class="fa fa-arrow-right mr-1"></span>
            بازگشت
          </v-btn>
        </div>
      </v-stepper-content>

      <v-stepper-step step="3">
        مرحله ۳
        <small>مشخصات سایت</small>
      </v-stepper-step>
      <v-stepper-content class="mx-0 px-1 pr-2" step="3">
        <div class="mt-2" v-if="step===3">
          <programming-select class="mt-5" v-if="data.type==='logo'"
                              v-model="data.size"></programming-select>
          <div v-if="data.type==='logo'" class="">
            <span class="text-center pb-2">لطفا یک یا چند لوگوی مورد علاقه خود را برای ما ارسال کنید. تا تیم طراحی ما، نیاز شما را بهتر درک کنند.</span>
          </div>
          <div class="" v-if="data.type==='visit_card'">
            <span class="text-center pb-2">لطفا عکس یک یا چند کارت ویزیت مورد علاقه خود را برای ما ارسال کنید. تا تیم طراحی ما نیاز شما را بهتر درک کنند.</span>
          </div>
          <v-file-input
              v-model="data.file"
              label=" بارگذاری عکس "
              outlined
              accept="image/png, image/jpeg,image/jpg, image/bmp"
              placeholder="عکس موردنظر خود را بارگذاری کنید."
              hint="حداکثر حجم هر عکس مورد نظر می‌تواند 1 مگابابت باشد."
              prepend-inner-icon="mdi-camera"
              clearable
              small-chips
              multiple
              clear-icon="mdi-close-circle-outline"
              prepend-icon=""
              dense
              class="mt-1 pt-1"
          >
          </v-file-input>
        </div>
        <div class="row justify-content-between py-2 mx-auto">
          <v-btn class="submit-btn col-md-1 col-3" @click="step3Validate">
            ادامه
            <span class="fa fa-arrow-left mr-1"></span>
          </v-btn>
          <v-btn class="mx-4 btn-refund col-md-1 col-3" @click="step = 2">
            <span class="fa fa-arrow-right mr-1"></span>
            بازگشت
          </v-btn>
        </div>
      </v-stepper-content>

      <v-stepper-step step="4">
        مرحله ۴
        <small>زمان تحویل</small>
      </v-stepper-step>
      <v-stepper-content class="mx-0 px-1 pr-2" step="4">
        <div class="m-3" v-if="data.type==='visit_card'">
          <span class="text-center pb-2">لطفا لوگو برند خودرابارگذاری کنید</span>
        </div>
        <v-file-input
            v-if="data.type==='visit_card'"
            v-model="data.brandLogo"
            label=" بارگذاری عکس "
            outlined
            accept="image/png,image/jpeg"
            placeholder="لطفا لوگو برند خودرابارگذاری کنید."
            hint="حداکثر حجم هر عکس مورد نظر می‌تواند 1 مگابابت باشد."
            prepend-inner-icon="mdi-camera"
            clearable
            small-chips
            clear-icon="mdi-close-circle-outline"
            prepend-icon=""
            multiple
            dense
            class="mt-1 mx-3 pt-1"
        >
        </v-file-input>
        <div class="col">
          <date-picker
              v-model="data.deliveryTime"
              color="#00acc1"
              label="زمان تحویل"
              input-class="mb-0 rounded"
              persianDigits
              clearable
              :timezone="false"
              format="YYYY-MM-DD"
              style="font-size: 13px!important"
              class="dateSet"
              display-format="jMMMM jD"
              :min="countDay"
          />
        </div>
        <div class="m-3" v-if="data.type==='visit_card'">
          <p class="pb-2">لطفا متون ومندرجات روی کارت ویزیت خود را تایپ کنید.</p>
          <V8Editor v-model="data.headerTexts"/>

          <p v-if="data.designType==='twoSide'" class="mt-10 pb-2">لطفا متون ومندرجات پشت کارت ویزیت خود را تایپ
            کنید.</p>
          <V8Editor v-if="data.designType==='twoSide'"
                    v-model="data.backText"/>
        </div>

        <div class="row justify-content-between py-2 mx-auto">
          <v-btn class="submit-btn col-md-1 col-3" @click="step4Validate">
            <span class="fa fa-arrow-left mr-1"></span>
            ادامه
          </v-btn>
          <v-btn class="mx-4 btn-refund col-md-1 col-3" @click="step = 3">
            <span class="fa fa-arrow-right mr-1"></span>
            بازگشت
          </v-btn>
        </div>
      </v-stepper-content>


      <v-stepper-step step="5">
        مرحله ۵
        <small>توضیحات</small>
      </v-stepper-step>
      <v-stepper-content class="mx-0 px-1 pr-2" step="5">
        <div class="mt-1">
          <div class="pb-2">
            <span class="text-center pb-2">لطفا توضیحات تکمیلی خود در مورد نیازتان را برای متخصصان ما یادداشت نمایید، تا بتوانیم به بهترین شکل ممکن درخواست شما را بررسی و پاسخ دهیم.</span>
          </div>
          <V8Editor class="mt-2" v-model="data.description"/>
        </div>
        <div class="row justify-content-between py-2 mx-auto">
          <v-btn :loading="isLoading" v-if="data.type!=='logo'" class="submit-btn col-md-1 px-5 col-3 mt-5"
                 @click="submit">
            <span class="fa fa-save mr-1"></span>
            ثبت سفارش
          </v-btn>
          <v-btn :loading="isLoading" v-if="data.type==='logo'" class="submit-btn col-md-1 px-5 col-4 mt-5"
                 @click="submitLogo">
            <span class="fa fa-save mr-1"></span>
            ثبت سفارش
          </v-btn>
          <v-btn class="mx-4 mt-5 col-md-1 col-4 btn-refund" @click="step = 4">
            <span class="fa fa-arrow-right mr-1"></span>
            بازگشت
          </v-btn>
        </div>
      </v-stepper-content>

    </v-stepper>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditorUploadAdapterPlugin from "../../../core/plugins/CKEditorUploadFileAdapter";
import LogoType from "../components/logoType";
import LangType from "../components/langType";
import Properties from "../components/properties";
import SabkType from "../components/sabkType";
import ColorPickers from "../components/colorPickers";
import CardType from "../components/cardType";
import DesignType from "../components/designType";
import DesignPaint from "../components/designPaint";
import ComplicativeType from "../components/complicativeType";
import ShapeType from "../components/shapeType";
import LogoShape from "../components/logoShape";
import {createFormData} from "@/Utilities/FormRequestHelper";
import CardSides from "@/view/pages/components/cardSides";

export default {
  name: "stepper",
  components: {
    CardSides,
    LogoShape,
    ShapeType,
    ComplicativeType,
    DesignPaint, DesignType, CardType, ColorPickers, SabkType, Properties, LangType, LogoType
  },
  data() {
    return {
      step: 1,
      days: '',
      marker: true,
      isLoading: false,
      orderType: [
        {text: 'فقط طراحی', value: 'design'},
        {text: 'طراحی به همراه چاپ', value: 'designPrint'},
      ],
      printCount: [
        {text: '۱,۰۰۰ عدد', value: '1000'},
        {text: '۲,۰۰۰ عدد', value: '2000'},
        {text: '۳,۰۰۰ عدد', value: '3000'},
        {text: '۴,۰۰۰ عدد', value: '4000'},
        {text: '۵,۰۰۰ عدد', value: '5000'},
        {text: '۱۰,۰۰۰ عدد', value: '10000'},
      ],
      editor: {
        editor: ClassicEditor,
        editorConfig: {
          language: 'fa',
          contentsLangDirection: 'rtl',
          extraPlugins: [CKEditorUploadAdapterPlugin],
        }
      },
      mainPrice: "",
      dialogPayment: false,
      designs: false,
      payDialogInfo: {},
      payableTransaction: null,
      selectedRows: [],
      paymentLoading: false,
      data: {
        organizationName: null,
        brandSlogan: null,
        slogan: 0,
        visitCardType: null,
        orderType: null,
        logo_size: null,
        headerTexts: null,
        diagram: null,
        designType: null,
        simpleness: null,
        logoShape: null,
        complexity: null,
        printCount: null,
        deliveryTime: null,
        color: [],
        hasBrandSlogan: false,
        preferredCurrency: 'Rial',
        brandName: null,
        logoLanguage: null,
        designStyle: null,
        softness: null,
        user_price: '',
        size: null,
        type: null,
        logoType: null,
        site_type: null,
        file: [],
        brandLogo: [],
        description: '',
        backText: ''
      },
      brandSlogan: null,
      orderTypes: [
        {key: 'logo', keyAlias: 'طراحی لوگو', icon: '/media/site/aparat.png'},
        {key: 'visit_card', keyAlias: 'طراحی کارت ویزیت', icon: '/media/site/aparat.png'},
        {key: 'office_set', keyAlias: 'طراحی ست اداری', icon: '/media/site/aparat.png'},
        {key: 'header', keyAlias: 'طراحی سربرگ', icon: '/media/site/aparat.png'},
        {key: 'poster', keyAlias: 'طراحی پوستر', icon: '/media/site/aparat.png'},
        {key: 'office_scan', keyAlias: 'طراحی و چاپ اداری', icon: '/media/site/aparat.png'},
      ],
      errors: [],
      dialog: false,
      loading: false,
      rules: [
        v => !!v || 'وارد کردن این فیلد الزامی است'
      ],
      urlRules: [
        (value) => this.isURL(value) || "دامنه سایت باید بصورت https://terminalads.com یا terminalads.com وارد شود. ",
      ],
      errorMsg: '',
      nameErr: '',
      pageTitle: '',
      userWallet: [],
      dialogInfo: null,
      tab: null,
      items: [
        'سفارش ها',
        'ثبت سفارش جدید',
      ],
      userInfo: {},
      statusBadge: '',
      userValid: true,
      isRejected: false,
      isPending: false,
      names: {},
      articleDesc: false,
      enterMine: false,
      userInfoGot: false
    }
  },
  methods: {
    persianName(name, field) {
      this.names[field] = name
    },
    isURL(str) {
      var regex = new RegExp("^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
      var without_regex = new RegExp("^([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
      if (regex.test(str) || without_regex.test(str)) {
        return true
      } else {
        return false;
      }
    },
    paymentDialog(data) {
      this.payDialogInfo = data
      this.dialogPayment = true
    },
    step1Validate() {
      if (!this.data.organizationName || !this.data.brandName) {
        this.$toast.error('نام برند و نام مجموعه الزامی است.')
        return
      } else if (this.data.hasBrandSlogan && !this.data.brandSlogan) {
        this.$toast.error('شعار برند خودرا بنویسید.');
        return
      } else if (this.data.slogan && !this.data.brandSlogan) {
        this.$toast.error('لطفا شعار برند خودرا وارد کنید.')
      } else
        this.step = 2
    },

    step2Validate() {
      if (this.data.type === 'logo') {
        const logo = [
          {main: this.data.logoType, name: 'نوع طراحی'},
          {main: this.data.logoShape, name: 'شکل هندسی'},
          {main: this.data.logoLanguage, name: 'زبان طراحی '},
          {main: this.data.softness, name: 'فرم و حالت'},
          {main: this.data.designStyle, name: 'سبک طراحی'},
          {main: this.data.color, name: 'رنگ'}
        ]

        for (let val of logo) {
          if (val.main === null || val.main.length <= 0) {
            this.$toast.error(val.name + ' لوگو ' + 'الزامی است.');
            return;
          }
        }
        this.step = 3;

      } else if (this.data.type === 'visit_card') {
        const visit = [
          {main: this.data.designType, name: 'نوع طرح '},
          {main: this.data.orderType, name: 'نوع سفارش '},
          {main: this.data.logoLanguage, name: 'زبان طراحی '},
          {main: this.data.color, name: 'رنگ'},
          {main: this.data.diagram, name: 'شکل هندسی '},
          {main: this.data.complexity, name: 'نوع طراحی'},
          {main: this.data.simpleness, name: 'سبک طراحی'},
        ];

        for (let val of visit)
          if (val.main === null || val.main.length <= 0) {
            this.$toast.error(val.name + ' کارت ویزیت ' + 'الزامی است.');
            return;
          }

        if (this.data.orderType === 'designPrint' && !this.data.visitCardType) {
          this.$toast.error('نوع کارت ویزیت الزامی است.')
          return;
        } else if (this.data.orderType === 'designPrint' && !this.data.printCount) {
          this.$toast.error('تعداد چاپ الزامی است.')
          return false;
        }
        this.step = 3
      }
      ;
    },

    step3Validate() {
      if (this.data.type === 'logo' && !this.data.size) {
        this.$toast.error('سایزلوگو الزامی است.')
      } else
        this.step = 4
    },
    step4Validate() {
      if ((this.data.type === 'visit_card' && this.data.designType === 'twoSide') && (!this.data.headerTexts || !this.data.backText)) {
        this.$toast.error('تمامی مندرجات خواسته شده را وارد نمایید.')
        return
      } else if (!this.data.deliveryTime) {
        this.$toast.error('زمان تحویل سفارش خودرا تکمیل کنید.')
        return;
      } else if (this.data.type === 'visit_card' && this.data.brandLogo.length <= 0) {
        this.$toast.error('بارگذاری لوگوی برند شماالزامی است.')
        return;
      } else if (this.data.type === 'visit_card' && !this.data.headerTexts) {
        this.$toast.error('مندرجات روی کارت ویزیت الزامی است.')
        return;
      } else
        this.step = 5
    },

    submitLogo() {
      this.isLoading = true;
      this.requestApiPost(`form/graphic/logo`, createFormData(this.data))
          .then((res) => {
            if (res.status && res.status === 201) {
              this.isLoading = false
              this.$emit('eventname', 1);
              this.$modal.hideLoading();
              this.$toast.success('با موفقیت ثبت شد.');
            } else {
              this.isLoading = false;
              this.$toast.error('لطفا مجددا تلاش کنید')
            }
          })
          .catch((e) => {
            this.isLoading = false;
            if (e.response.status === 500) {
              this.$toast.error('خطای سمت سرور!')
            } else
              this.$nextTick(() => {
                this.$toast.error(Object.values(e.response.data.errors).map((x) => {
                  return x.join('\n');
                }).join(''));
              })

            this.errors = e.response.data.errors
          })
          .finally(() => {
            this.isLoading = false;
            this.$modal.hideLoading();
          })
    },

    submit() {
      if ((this.$route.name === 'support.index' && !this.data.description) || (this.$route.name === 'support.index' && !this.data.support_time)) {
        this.$toast.error('تمامی فیلدهای نمایش داده شده اجباری می باشند.');
        return;

      } else {
        this.isLoading = true;
        this.requestApiPost(`form/graphic/visitCards`, createFormData(this.data))
            .then((res) => {
              if (res.status && res.status === 201) {
                this.isLoading = false;
                this.$emit('eventname', 1)
                this.$toast.success('با موفقیت ثبت شد.');
              } else {
                this.isLoading = false
                this.$toast.error('لطفا مجددا تلاش کنید')
              }
            })
            .catch((e) => {
              this.isLoading = false
              this.$toast.error(Object.values(e.response.data.errors).map((x) => {
                return x.join('\n');
              }).join(''));

              this.errors = e.response.data.errors
            })
            .finally(() => {
              this.isLoading = false;
              this.$modal.hideLoading();
            })
      }
    },
    pay(transactionId) {
      if (this.payDialogInfo.payments.type === 'final') {

        this.requestApiPost(`payment/${this.payDialogInfo.id}/pay`, {transaction_id: this.payDialogInfo.payments.transactions[0].id})
            .then(response => {
              this.$toast.success('با موفقیت پرداخت شد!')
              this.getSites()
              this.dialogPayment = false
            }).catch(({res}) => {
          this.loading = false
          this.$toast.error(res.data.message)
        })


      } else {
        this.requestApiPost(`payment/${this.payDialogInfo.id}/pay`, {transaction_id: transactionId})
            .then(response => {
              this.$toast.success('با موفقیت پرداخت شد!')
              this.getSites()
              this.dialogPayment = false
            }).catch(({res}) => {
          this.loading = false
          this.$toast.error(res.data.message)
        })

      }
    },
    getSites(url = this.url, params = this.tableProps) {
      this.$modal.showLoading();
      this.requestApiGet(url, params).then(response => {
        this.userInfo = response.data;
      }).finally(() => {
        this.$modal.hideLoading();
        if (!this.userInfoGot) {
          this.getUserInfo();
        }
      })
    },
    edit(data) {
      this.$router.push({name: 'admin.user.edit', params: {id: data.id}})
    },
    information(data) {
      this.$router.push({name: 'admin.users.information', params: {id: data.id}})
    },
    checkRoutes() {
      if (this.$route.name === 'logo.index') {
        this.data.type = 'logo';
        this.pageTitle = this.orderTypes[0].keyAlias;
      } else if (this.$route.name === 'support.index') {
        this.data.type = 'support';
        this.pageTitle = this.orderTypes[1].keyAlias;
      } else {
        this.data.type = 'visit_card';
        this.pageTitle = this.orderTypes[1].keyAlias;
      }

    },
    changeUnit() {
      this.marker = !this.marker;
      if (this.marker) {
        this.data.preferredCurrency = 'Rial'
      } else this.data.preferredCurrency = 'Toman'
    }
  },
  watch: {
    'data.organozationName': function (value) {
      var regex = /^[a-zA-Z]+$/;
      if (value > 3 && !value.match(regex)) {
        this.nameErr = 'نام مجموعه نمیتواند تنها شامل اعداد باشد.'
      } else
        this.nameErr = '';
    },
    'data.hasBrandSlogan': function (value) {
      if (value) {
        this.data.brandSlogan = this.brandSlogan;
      } else this.data.brandSlogan = null
    },
    'data.slogan': function (value) {
      if (value) {
        this.data.slogan = 1
      } else this.data.slogan = 0
    }
  },
  computed: {
    main_price: {
      get() {
        return this.$options.filters.currency(this.data.user_price)
      },
      set(value) {
        this.data.user_price = value.replaceAll(',', '')
      }
    },
    countDay: {
      get() {
        const minimum_day = new Date();
        minimum_day.setDate(minimum_day.getDate() + 5);
        return minimum_day;
      },
      set(value) {
      }
    },
    printCounting: {
      set(value) {
        this.data.printCount = value * 1000;
      },
    },
  },
  mounted() {
    this.checkRoutes();
  }
}
</script>

<style scoped>

</style>